/******* NOTE ********
The APIs for the RiskMinder client have changed.
This file is to retain older APIs for backward compatibility.
It should not be included in the next release of the client.

Functional methods
-----------------------
Following methods still work appropriately:

1)ArcotRFClient() //to enable instantiation
2)load() //to enable callback function only
3)setFlashCookie(), getFlashCookie(), getFlashCookieValue(), getBrowserCookie(), setBrowserCookie(), deleteBrowserCookie()
//These will internally use the default storage mechanism (and not necessarily flash/browser cookies
4) analyzeDeviceDNA 
//Processes DeviceDNA
5) getDNAString   
//Returns DeviceDNA string in JSON format
6) formatAsHTML 
//Returns DeviceDNA as HTML string
7) getDNAExecutionTime 
//Returns time taken to execute DDNA

Dummy methods
-----------------------
Following methods are set to return string 0, because something needs to be returned
1) getMESCValue
2) getMESCIterationsCompleted
3) getDESCValue

Following methods dont' do anything now
1) setDNAConfiguration 
2) setMESCConfiguration 
3) setDESCConfiguration 
4) setJavaAppletPathURL 
4) setFlashParams 


*/

/* eslint-disable */

if (typeof arcotrf == 'undefined') {
  var arcotrf = {};
}

arcotrf.ArcotRFClient = function() {
  this.client = new ca.rm.Client();
};

//console.log('-----> : riskminder.() ------> arcotrf.ArcotRFClient: ', arcotrf.ArcotRFClient);

window.arcotrf = arcotrf;

arcotrf.ArcotRFClient.prototype.client;
arcotrf.ArcotRFClient.prototype.callback;
arcotrf.ArcotRFClient.prototype.lsoVal;

//console.log('-----> : riskminder.() ------> window.arcotrf: ', window.arcotrf);

arcotrf.ArcotRFClient.prototype.load = function(
  callbackFunc,
  wrapperDivId,
  flashCookie,
  dna,
  flashDNA,
  javaDNA,
  pluginDNA,
  wrapperDivDisplayStyle
) {
  if (callbackFunc) {
    callbackFunc();
  }
};

arcotrf.ArcotRFClient.prototype.getError = function() {
  return 'This method is deprecated';
};

arcotrf.ArcotRFClient.prototype.getLog = function() {
  return 'This method is deprecated';
};

arcotrf.ArcotRFClient.prototype.setFlashCookie = function(cookieNm, cookieVal, onDone) {
  this.client.setProperty('didname', cookieNm);
  this.client.setDID(cookieVal);
  if (onDone) {
    onDone();
  }
};

arcotrf.ArcotRFClient.prototype.getFlashCookie = function(cookieNm, onDone) {
  this.client.setProperty('didname', cookieNm);
  this.lsoVal = this.client.getDID();
  if (onDone) {
    onDone();
  }
};

arcotrf.ArcotRFClient.prototype.getFlashCookieValue = function() {
  return this.lsoVal;
};

arcotrf.ArcotRFClient.prototype.getBrowserCookie = function(name) {
  this.client.setProperty('didname', name);
  return this.client.getDID();
};

arcotrf.ArcotRFClient.prototype.setBrowserCookie = function(name, value, days2live, domain) {
  this.client.setProperty('didname', name);
  this.client.setDID(value);
};

arcotrf.ArcotRFClient.prototype.deleteBrowserCookie = function(name) {
  this.client.setProperty('didname', name);
  this.client.deleteDID();
};

arcotrf.ArcotRFClient.prototype.analyzeDeviceDNA = function(onDone, maxDurationMSec) {
  this.client.processDNA();

  if (onDone) {
    onDone();
  }
};

arcotrf.ArcotRFClient.prototype.getDNAString = function(formatCode) {
  this.client.setProperty('format', 'json');
  return this.client.getDNA();
};

arcotrf.ArcotRFClient.prototype.formatAsHTML = function() {
  this.client.setProperty('format', 'html');
  return this.client.getDNA();
};

arcotrf.ArcotRFClient.prototype.getDNAExecutionTime = function() {
  return this.client.getTimeTaken();
};

arcotrf.ArcotRFClient.prototype.getMESCValue = function() {
  //Return dummy data
  return -1;
};

arcotrf.ArcotRFClient.prototype.getMESCIterationsCompleted = function() {
  //Return dummy data
  return -1;
};

arcotrf.ArcotRFClient.prototype.getDESCValue = function() {
  //Return dummy data
  return -1;
};

arcotrf.ArcotRFClient.prototype.setDNAConfiguration = function(
  externalIPAddr,
  internalIPDivID,
  macDivID,
  ieClientCapsDivId
) {
  //Does nothing
};

arcotrf.ArcotRFClient.prototype.setMESCConfiguration = function(
  isMESCOn,
  numberOfIterations,
  calibrationDuration,
  intervalDelay
) {
  //Does nothing
};

arcotrf.ArcotRFClient.prototype.setDESCConfiguration = function(
  isDESCOn,
  numberOfIterations,
  calibrationDuration,
  neverUseFlash
) {
  //Does nothing
};

arcotrf.ArcotRFClient.prototype.setJavaAppletPathURL = function(appletBaseURL) {
  //Does nothing
};

arcotrf.ArcotRFClient.prototype.setFlashParams = function(
  flashDivId,
  movieUrl,
  maxRetries,
  retryPeriodMSec
) {
  //Does nothing
};

function aotpLog(log) {}

/* PluginDetect v0.6.3 [ onWindowLoaded isMinVersion getVersion onDetectionDone Java(OTF&NOTF&getInfo) QT DevalVR Shockwave Flash WMP Silverlight VLC ] by Eric Gerds www.pinlady.net/PluginDetect */
if (!PluginDetect) {
  var PluginDetect = {
    getNum: function(b, c) {
      if (!this.num(b)) {
        return null;
      }
      var a;
      if (typeof c == 'undefined') {
        a = /[\d][\d\.\_,-]*/.exec(b);
      } else {
        a = new RegExp(c).exec(b);
      }
      return a ? a[0].replace(/[\.\_-]/g, ',') : null;
    },
    hasMimeType: function(c) {
      if (PluginDetect.isIE) {
        return null;
      }
      var b,
        a,
        d,
        e = c.constructor == String ? [c] : c;
      for (d = 0; d < e.length; d++) {
        b = navigator.mimeTypes[e[d]];
        if (b && b.enabledPlugin) {
          a = b.enabledPlugin;
          if (a.name || a.description) {
            return b;
          }
        }
      }
      return null;
    },
    findNavPlugin: function(g, d) {
      var a = g.constructor == String ? g : g.join('.*'),
        e = d === false ? '' : '\\d',
        b,
        c = new RegExp(a + '.*' + e + '|' + e + '.*' + a, 'i'),
        f = navigator.plugins;
      for (b = 0; b < f.length; b++) {
        if (c.test(f[b].description) || c.test(f[b].name)) {
          return f[b];
        }
      }
      return null;
    },
    AXO: window.ActiveXObject,
    getAXO: function(b, a) {
      var f = null,
        d,
        c = false;
      try {
        f = new this.AXO(b);
        c = true;
      } catch (d) {}
      if (typeof a != 'undefined') {
        f = null;
        return c;
      }
      return f;
    },
    num: function(a) {
      return typeof a != 'string' ? false : /\d/.test(a);
    },
    compareNums: function(g, e) {
      var d = this,
        c,
        b,
        a,
        f = window.parseInt;
      if (!d.num(g) || !d.num(e)) {
        return 0;
      }
      if (d.plugin && d.plugin.compareNums) {
        return d.plugin.compareNums(g, e);
      }
      c = g.split(',');
      b = e.split(',');
      for (a = 0; a < Math.min(c.length, b.length); a++) {
        if (f(c[a], 10) > f(b[a], 10)) {
          return 1;
        }
        if (f(c[a], 10) < f(b[a], 10)) {
          return -1;
        }
      }
      return 0;
    },
    formatNum: function(b) {
      if (!this.num(b)) {
        return null;
      }
      var a,
        c = b
          .replace(/\s/g, '')
          .replace(/[\.\_]/g, ',')
          .split(',')
          .concat(['0', '0', '0', '0']);
      for (a = 0; a < 4; a++) {
        if (/^(0+)(.+)$/.test(c[a])) {
          c[a] = RegExp.$2;
        }
      }
      if (!/\d/.test(c[0])) {
        c[0] = '0';
      }
      return c[0] + ',' + c[1] + ',' + c[2] + ',' + c[3];
    },
    initScript: function() {
      var $ = this,
        userAgent = navigator.userAgent;
      $.isIE =
        /*@cc_on!@*/
        false;
      $.IEver = $.isIE && /MSIE\s*(\d\.?\d*)/i.exec(userAgent) ? parseFloat(RegExp.$1, 10) : -1;
      $.ActiveXEnabled = false;
      if ($.isIE) {
        var x,
          progid = [
            'Msxml2.XMLHTTP',
            'Msxml2.DOMDocument',
            'Microsoft.XMLDOM',
            'ShockwaveFlash.ShockwaveFlash',
            'TDCCtl.TDCCtl',
            'Shell.UIHelper',
            'Scripting.Dictionary',
            'wmplayer.ocx',
          ];
        for (x = 0; x < progid.length; x++) {
          if ($.getAXO(progid[x], 1)) {
            $.ActiveXEnabled = true;
            break;
          }
        }
        $.head =
          typeof document.getElementsByTagName != 'undefined'
            ? document.getElementsByTagName('head')[0]
            : null;
      }
      $.isGecko =
        !$.isIE &&
        typeof navigator.product == 'string' &&
        /Gecko/i.test(navigator.product) &&
        /Gecko\s*\/\s*\d/i.test(userAgent)
          ? true
          : false;
      $.GeckoRV = $.isGecko
        ? $.formatNum(/rv\s*\:\s*([\.\,\d]+)/i.test(userAgent) ? RegExp.$1 : '0.9')
        : null;
      $.isSafari = !$.isIE && /Safari\s*\/\s*\d/i.test(userAgent) ? true : false;
      $.isChrome = /Chrome\s*\/\s*\d/i.test(userAgent) ? true : false;
      $.onWindowLoaded(0);
    },
    init: function(c, a) {
      if (typeof c != 'string') {
        return -3;
      }
      c = c.toLowerCase().replace(/\s/g, '');
      var b = this,
        d;
      if (typeof b[c] == 'undefined') {
        return -3;
      }
      d = b[c];
      b.plugin = d;
      if (typeof d.installed == 'undefined' || a == true) {
        d.installed = null;
        d.version = null;
        d.version0 = null;
        d.getVersionDone = null;
        d.$ = b;
      }
      b.garbage = false;
      if (b.isIE && !b.ActiveXEnabled) {
        if (b.plugin != b.java) {
          return -2;
        }
      }
      return 1;
    },
    isMinVersion: function(g, e, c, b) {
      var f = PluginDetect,
        d = f.init(g);
      if (d < 0) {
        return d;
      }
      if (typeof e == 'number') {
        e = e.toString();
      }
      if (typeof e != 'string') {
        e = '0';
      }
      if (!f.num(e)) {
        return -3;
      }
      e = f.formatNum(e);
      var a = -1,
        h = f.plugin;
      if (h.getVersionDone != 1) {
        h.getVersion(c, b);
        if (h.getVersionDone === null) {
          h.getVersionDone = 1;
        }
      }
      if (h.version !== null || h.installed !== null) {
        if (h.installed <= 0.5) {
          a = h.installed;
        } else {
          a = h.version === null ? 0 : f.compareNums(h.version, e) >= 0 ? 1 : -1;
        }
      }
      f.cleanup();
      return a;
      return -3;
    },
    getVersion: function(e, b, a) {
      var d = PluginDetect,
        c = d.init(e),
        f;
      if (c < 0) {
        return null;
      }
      f = d.plugin;
      if (f.getVersionDone != 1) {
        f.getVersion(b, a);
        if (f.getVersionDone === null) {
          f.getVersionDone = 1;
        }
      }
      d.cleanup();
      return f.version || f.version0;
      return null;
    },
    getInfo: function(f, c, b) {
      var a = {};
      var e = PluginDetect,
        d = e.init(f),
        g;
      if (d < 0) {
        return a;
      }
      g = e.plugin;
      if (typeof g.getInfo != 'undefined') {
        if (g.getVersionDone === null) {
          e.getVersion(f, c, b);
        }
        a = g.getInfo();
      }
      return a;
    },
    cleanup: function() {
      var a = this;
      if (a.garbage && typeof window.CollectGarbage != 'undefined') {
        window.CollectGarbage();
      }
    },
    isActiveXObject: function(b) {
      var d = this,
        a,
        g,
        f = '/',
        c =
          '<object width="1" height="1" style="display:none" ' +
          d.plugin.getCodeBaseVersion(b) +
          '>' +
          d.plugin.HTML +
          '<' +
          f +
          'object>';
      if (d.head.firstChild) {
        d.head.insertBefore(document.createElement('object'), d.head.firstChild);
      } else {
        d.head.appendChild(document.createElement('object'));
      }
      d.head.firstChild.outerHTML = c;
      try {
        d.head.firstChild.classid = d.plugin.classID;
      } catch (g) {}
      a = false;
      try {
        if (d.head.firstChild.object) {
          a = true;
        }
      } catch (g) {}
      try {
        if (a && d.head.firstChild.readyState < 4) {
          d.garbage = true;
        }
      } catch (g) {}
      d.head.removeChild(d.head.firstChild);
      return a;
    },
    codebaseSearch: function(c) {
      var e = this;
      if (!e.ActiveXEnabled) {
        return null;
      }
      if (typeof c != 'undefined') {
        return e.isActiveXObject(c);
      }
      var j = [0, 0, 0, 0],
        g,
        f,
        b = e.plugin.digits,
        i = function(k, m) {
          var l =
            (k == 0 ? m : j[0]) +
            ',' +
            (k == 1 ? m : j[1]) +
            ',' +
            (k == 2 ? m : j[2]) +
            ',' +
            (k == 3 ? m : j[3]);
          return e.isActiveXObject(l);
        };
      var h,
        d,
        a = false;
      for (g = 0; g < b.length; g++) {
        h = b[g] * 2;
        j[g] = 0;
        for (f = 0; f < 20; f++) {
          if (h == 1 && g > 0 && a) {
            break;
          }
          if (h - j[g] > 1) {
            d = Math.round((h + j[g]) / 2);
            if (i(g, d)) {
              j[g] = d;
              a = true;
            } else {
              h = d;
            }
          } else {
            if (h - j[g] == 1) {
              h--;
              if (!a && i(g, h)) {
                a = true;
              }
              break;
            } else {
              if (!a && i(g, h)) {
                a = true;
              }
              break;
            }
          }
        }
        if (!a) {
          return null;
        }
      }
      return j.join(',');
    },
    dummy1: 0,
  };
}
PluginDetect.onDetectionDone = function(g, e, d, a) {
  var c = PluginDetect,
    b = c.init(g),
    h;
  if (b == -3) {
    return -1;
  }
  if (c.plugin.getVersionDone != 1) {
    h = c.isMinVersion(g, '0', d, a);
    if (h == -3) {
      h = c.getVersion(g, d, a);
    }
  }
  if (c.plugin.installed != -0.5 && c.plugin.installed != 0.5) {
    if (typeof e == 'function') {
      e(c);
    }
    return 1;
  }
  if (c.plugin != c.java) {
    return 1;
  }
  c.plugin.NOTF.SetupAppletQuery();
  if (typeof e == 'function') {
    c.plugin.funcs[c.plugin.funcs.length] = e;
  }
  return 0;
  return -1;
};
PluginDetect.onWindowLoaded = function(c) {
  var b = PluginDetect,
    a = window;
  if (b.EventWinLoad === true) {
  } else {
    b.winLoaded = false;
    b.EventWinLoad = true;
    if (typeof a.addEventListener != 'undefined') {
      a.addEventListener('load', b.runFuncs, false);
    } else {
      if (typeof a.attachEvent != 'undefined') {
        a.attachEvent('onload', b.runFuncs);
      } else {
        if (typeof a.onload == 'function') {
          b.funcs[b.funcs.length] = a.onload;
        }
        a.onload = b.runFuncs;
      }
    }
  }
  if (typeof c == 'function') {
    b.funcs[b.funcs.length] = c;
  }
};
PluginDetect.funcs = [0];
PluginDetect.runFuncs = function() {
  var b = PluginDetect,
    a;
  b.winLoaded = true;
  for (a = 0; a < b.funcs.length; a++) {
    if (typeof b.funcs[a] == 'function') {
      b.funcs[a](b);
      b.funcs[a] = null;
    }
  }
};
PluginDetect.quicktime = {
  mimeType: [
    'video/quicktime',
    'application/x-quicktimeplayer',
    'image/x-macpaint',
    'image/x-quicktime',
  ],
  progID: 'QuickTimeCheckObject.QuickTimeCheck.1',
  progID0: 'QuickTime.QuickTime',
  classID: 'clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B',
  minIEver: 7,
  HTML: '<param name="src" value="A14999.mov" /><param name="controller" value="false" />',
  getCodeBaseVersion: function(a) {
    return 'codebase="#version=' + a + '"';
  },
  digits: [8, 64, 16, 0],
  clipTo3digits: function(f) {
    if (f === null || typeof f == 'undefined') {
      return null;
    }
    var e,
      d,
      h,
      g = this.$;
    e = f.split(',');
    if (g.compareNums(f, '7,60,0,0') < 0 && g.compareNums(f, '7,50,0,0') >= 0) {
      d = e[0] + ',' + e[1].charAt(0) + ',' + e[1].charAt(1) + ',' + e[2];
    } else {
      d = e[0] + ',' + e[1] + ',' + e[2] + ',' + e[3];
    }
    h = d.split(',');
    return h[0] + ',' + h[1] + ',' + h[2] + ',0';
  },
  getVersion: function() {
    var a = null,
      d,
      b = this.$,
      e = true;
    if (!b.isIE) {
      if (navigator.platform && /linux/i.test(navigator.platform)) {
        e = false;
      }
      if (e) {
        d = b.findNavPlugin(['QuickTime', '(Plug-in|Plugin)']);
        if (d && d.name && b.hasMimeType(this.mimeType)) {
          a = b.getNum(d.name);
        }
      }
      this.installed = a ? 1 : -1;
    } else {
      var c;
      if (b.IEver >= this.minIEver && b.getAXO(this.progID0, 1)) {
        a = b.codebaseSearch();
      } else {
        c = b.getAXO(this.progID);
        if (c && c.QuickTimeVersion) {
          a = c.QuickTimeVersion.toString(16);
          a = a.charAt(0) + '.' + a.charAt(1) + '.' + a.charAt(2);
        }
      }
      this.installed = a ? 1 : b.getAXO(this.progID0, 1) ? 0 : -1;
    }
    this.version = this.clipTo3digits(b.formatNum(a));
  },
};
PluginDetect.java = {
  mimeType: 'application/x-java-applet',
  classID: 'clsid:8AD9C840-044E-11D1-B3E9-00805F499D93',
  DTKclassID: 'clsid:CAFEEFAC-DEC7-0000-0000-ABCDEFFEDCBA',
  DTKmimeType: 'application/npruntime-scriptable-plugin;DeploymentToolkit',
  JavaVersions: [
    [1, 9, 2, 25],
    [1, 8, 2, 25],
    [1, 7, 2, 25],
    [1, 6, 2, 25],
    [1, 5, 2, 25],
    [1, 4, 2, 25],
    [1, 3, 1, 25],
  ],
  searchJavaPluginAXO: function() {
    var h = null,
      a = this,
      c = a.$,
      g = [],
      j = [1, 5, 0, 14],
      i = [1, 6, 0, 2],
      f = [1, 3, 1, 0],
      e = [1, 4, 2, 0],
      d = [1, 5, 0, 7],
      b = false;
    if (!c.ActiveXEnabled) {
      return null;
    }
    b = true;
    if (c.IEver >= a.minIEver) {
      g = a.searchJavaAXO(i, i, b);
      if (g.length > 0 && b) {
        g = a.searchJavaAXO(j, j, b);
      }
    } else {
      if (b) {
        g = a.searchJavaAXO(d, d, true);
      }
      if (g.length == 0) {
        g = a.searchJavaAXO(f, e, false);
      }
    }
    if (g.length > 0) {
      h = g[0];
    }
    a.JavaPlugin_versions = [].concat(g);
    return h;
  },
  searchJavaAXO: function(l, i, m) {
    var n,
      f,
      h = this.$,
      p,
      k,
      a,
      e,
      g,
      j,
      b,
      q = [];
    if (h.compareNums(l.join(','), i.join(',')) > 0) {
      i = l;
    }
    i = h.formatNum(i.join(','));
    var o,
      d = '1,4,2,0',
      c =
        'JavaPlugin.' +
        l[0] +
        '' +
        l[1] +
        '' +
        l[2] +
        '' +
        (l[3] > 0 ? '_' + (l[3] < 10 ? '0' : '') + l[3] : '');
    for (n = 0; n < this.JavaVersions.length; n++) {
      f = this.JavaVersions[n];
      p = 'JavaPlugin.' + f[0] + '' + f[1];
      g = f[0] + '.' + f[1] + '.';
      for (a = f[2]; a >= 0; a--) {
        b = 'JavaWebStart.isInstalled.' + g + a + '.0';
        if (h.compareNums(f[0] + ',' + f[1] + ',' + a + ',0', i) >= 0 && !h.getAXO(b, 1)) {
          continue;
        }
        o = h.compareNums(f[0] + ',' + f[1] + ',' + a + ',0', d) < 0 ? true : false;
        for (e = f[3]; e >= 0; e--) {
          k = a + '_' + (e < 10 ? '0' + e : e);
          j = p + k;
          if (h.getAXO(j, 1) && (o || h.getAXO(b, 1))) {
            q[q.length] = g + k;
            if (!m) {
              return q;
            }
          }
          if (j == c) {
            return q;
          }
        }
        if (h.getAXO(p + a, 1) && (o || h.getAXO(b, 1))) {
          q[q.length] = g + a;
          if (!m) {
            return q;
          }
        }
        if (p + a == c) {
          return q;
        }
      }
    }
    return q;
  },
  minIEver: 7,
  getFromMimeType: function(a) {
    var h,
      f,
      c = this.$,
      j = new RegExp(a),
      d,
      k,
      i = {},
      e = 0,
      b,
      g = [''];
    for (h = 0; h < navigator.mimeTypes.length; h++) {
      k = navigator.mimeTypes[h];
      if (j.test(k.type) && k.enabledPlugin) {
        k = k.type.substring(k.type.indexOf('=') + 1, k.type.length);
        d = 'a' + c.formatNum(k);
        if (typeof i[d] == 'undefined') {
          i[d] = k;
          e++;
        }
      }
    }
    for (f = 0; f < e; f++) {
      b = '0,0,0,0';
      for (h in i) {
        if (i[h]) {
          d = h.substring(1, h.length);
          if (c.compareNums(d, b) > 0) {
            b = d;
          }
        }
      }
      g[f] = i['a' + b];
      i['a' + b] = null;
    }
    if (!/windows|macintosh/i.test(navigator.userAgent)) {
      g = [g[0]];
    }
    return g;
  },
  queryJavaHandler: function() {
    var b = PluginDetect.java,
      a = window.java,
      c;
    b.hasRun = true;
    try {
      if (typeof a.lang != 'undefined' && typeof a.lang.System != 'undefined') {
        b.value = [
          a.lang.System.getProperty('java.version') + ' ',
          a.lang.System.getProperty('java.vendor') + ' ',
        ];
      }
    } catch (c) {}
  },
  queryJava: function() {
    var c = this,
      d = c.$,
      b = navigator.userAgent,
      f;
    if (typeof window.java != 'undefined' && navigator.javaEnabled() && !c.hasRun) {
      if (d.isGecko) {
        if (d.hasMimeType('application/x-java-vm')) {
          try {
            var g = document.createElement('div'),
              a = document.createEvent('HTMLEvents');
            a.initEvent('focus', false, true);
            g.addEventListener('focus', c.queryJavaHandler, false);
            g.dispatchEvent(a);
          } catch (f) {}
          if (!c.hasRun) {
            c.queryJavaHandler();
          }
        }
      } else {
        if (/opera.9\.(0|1)/i.test(b) && /mac/i.test(b)) {
        } else {
          if (!c.hasRun) {
            c.queryJavaHandler();
          }
        }
      }
    }
    return c.value;
  },
  forceVerifyTag: [],
  jar: [],
  VENDORS: ['Sun Microsystems Inc.', 'Apple Computer, Inc.'],
  init: function() {
    var a = this,
      b = a.$;
    if (typeof a.app != 'undefined') {
      a.delJavaApplets(b);
    }
    a.hasRun = false;
    a.value = [null, null];
    a.useTag = [2, 2, 2];
    a.app = [0, 0, 0, 0, 0, 0];
    a.appi = 3;
    a.queryDTKresult = null;
    a.OTF = 0;
    a.BridgeResult = [[null, null], [null, null], [null, null]];
    a.JavaActive = [0, 0, 0];
    a.All_versions = [];
    a.DeployTK_versions = [];
    a.MimeType_versions = [];
    a.JavaPlugin_versions = [];
    a.funcs = [];
    var c = a.NOTF;
    if (c) {
      c.$ = b;
      if (c.javaInterval) {
        clearInterval(c.javaInterval);
      }
      c.EventJavaReady = null;
      c.javaInterval = null;
      c.count = 0;
      c.intervalLength = 250;
      c.countMax = 40;
    }
    a.lateDetection = b.winLoaded;
    if (!a.lateDetection) {
      b.onWindowLoaded(a.delJavaApplets);
    }
  },
  getVersion: function(f, l) {
    var h,
      d = this,
      g = d.$,
      j = null,
      n = null,
      e = null,
      c = navigator.javaEnabled();
    if (d.getVersionDone === null) {
      d.init();
    }
    var k;
    if (typeof l != 'undefined' && l.constructor == Array) {
      for (k = 0; k < d.useTag.length; k++) {
        if (typeof l[k] == 'number') {
          d.useTag[k] = l[k];
        }
      }
    }
    for (k = 0; k < d.forceVerifyTag.length; k++) {
      d.useTag[k] = d.forceVerifyTag[k];
    }
    if (typeof f != 'undefined') {
      d.jar[d.jar.length] = f;
    }
    if (d.getVersionDone == 0) {
      if (!d.version || d.useAnyTag()) {
        h = d.queryExternalApplet(f);
        if (h[0]) {
          e = h[0];
          n = h[1];
        }
      }
      d.EndGetVersion(e, n);
      return;
    }
    var i = d.queryDeploymentToolKit();
    if (typeof i == 'string' && i.length > 0) {
      j = i;
      n = d.VENDORS[0];
    }
    if (!g.isIE) {
      var q, m, b, o, a;
      a = g.hasMimeType(d.mimeType);
      o = a && c ? true : false;
      if (d.MimeType_versions.length == 0 && a) {
        h = d.getFromMimeType('application/x-java-applet.*jpi-version.*=');
        if (h[0] != '') {
          if (!j) {
            j = h[0];
          }
          d.MimeType_versions = h;
        }
      }
      if (!j && a) {
        h = 'Java[^\\d]*Plug-in';
        b = g.findNavPlugin(h);
        if (b) {
          h = new RegExp(h, 'i');
          q = h.test(b.description) ? g.getNum(b.description) : null;
          m = h.test(b.name) ? g.getNum(b.name) : null;
          if (q && m) {
            j = g.compareNums(g.formatNum(q), g.formatNum(m)) >= 0 ? q : m;
          } else {
            j = q || m;
          }
        }
      }
      if (!j && a && /macintosh.*safari/i.test(navigator.userAgent)) {
        b = g.findNavPlugin('Java.*\\d.*Plug-in.*Cocoa', false);
        if (b) {
          q = g.getNum(b.description);
          if (q) {
            j = q;
          }
        }
      }
      if (j) {
        d.version0 = j;
        if (c) {
          e = j;
        }
      }
      if (!e || d.useAnyTag()) {
        b = d.queryExternalApplet(f);
        if (b[0]) {
          e = b[0];
          n = b[1];
        }
      }
      if (!e) {
        b = d.queryJava();
        if (b[0]) {
          d.version0 = b[0];
          e = b[0];
          n = b[1];
          if (d.installed == -0.5) {
            d.installed = 0.5;
          }
        }
      }
      if (d.installed === null && !e && o && !/macintosh.*ppc/i.test(navigator.userAgent)) {
        h = d.getFromMimeType('application/x-java-applet.*version.*=');
        if (h[0] != '') {
          e = h[0];
        }
      }
      if (!e && o) {
        if (/macintosh.*safari/i.test(navigator.userAgent)) {
          if (d.installed === null) {
            d.installed = 0;
          } else {
            if (d.installed == -0.5) {
              d.installed = 0.5;
            }
          }
        }
      }
    } else {
      if (!j && i != -1) {
        j = d.searchJavaPluginAXO();
        if (j) {
          n = d.VENDORS[0];
        }
      }
      if (!j) {
        d.JavaFix();
      }
      if (j) {
        d.version0 = j;
        if (c && g.ActiveXEnabled) {
          e = j;
        }
      }
      if (!e || d.useAnyTag()) {
        h = d.queryExternalApplet(f);
        if (h[0]) {
          e = h[0];
          n = h[1];
        }
      }
    }
    if (d.installed === null) {
      d.installed = e ? 1 : j ? -0.2 : -1;
    }
    d.EndGetVersion(e, n);
  },
  EndGetVersion: function(b, d) {
    var a = this,
      c = a.$;
    if (a.version0) {
      a.version0 = c.formatNum(c.getNum(a.version0));
    }
    if (b) {
      a.version = c.formatNum(c.getNum(b));
      a.vendor = typeof d == 'string' ? d : '';
    }
    if (a.getVersionDone != 1) {
      a.getVersionDone = 0;
    }
  },
  queryDeploymentToolKit: function() {
    var d = this,
      g = d.$,
      i,
      b,
      h = null,
      a = null;
    if (
      (g.isGecko && g.compareNums(g.GeckoRV, g.formatNum('1.6')) <= 0) ||
      g.isSafari ||
      (g.isIE && !g.ActiveXEnabled)
    ) {
      d.queryDTKresult = 0;
    }
    if (d.queryDTKresult !== null) {
      return d.queryDTKresult;
    }
    if (g.isIE && g.IEver >= 6) {
      d.app[0] = g.instantiate('object', [], []);
      h = g.getObject(d.app[0]);
    } else {
      if (!g.isIE && g.hasMimeType(d.DTKmimeType)) {
        d.app[0] = g.instantiate('object', ['type', d.DTKmimeType], []);
        h = g.getObject(d.app[0]);
      }
    }
    if (h) {
      if (g.isIE && g.IEver >= 6) {
        try {
          h.classid = d.DTKclassID;
        } catch (i) {}
      }
      try {
        var c,
          f = h.jvms;
        if (f) {
          a = f.getLength();
          if (typeof a == 'number') {
            for (b = 0; b < a; b++) {
              c = f.get(a - 1 - b);
              if (c) {
                c = c.version;
                if (g.getNum(c)) {
                  d.DeployTK_versions[b] = c;
                }
              }
            }
          }
        }
      } catch (i) {}
    }
    g.hideObject(h);
    d.queryDTKresult = d.DeployTK_versions.length > 0 ? d.DeployTK_versions[0] : a == 0 ? -1 : 0;
    return d.queryDTKresult;
  },
  queryExternalApplet: function(d) {
    var c = this,
      e = c.$,
      h = c.BridgeResult,
      b = c.app,
      g = c.appi,
      a = '&nbsp;&nbsp;&nbsp;&nbsp;';
    if (typeof d != 'string' || !/\.jar\s*$/.test(d)) {
      return [null, null];
    }
    if (c.OTF < 1) {
      c.OTF = 1;
    }
    if (!e.isIE) {
      if ((e.isGecko || e.isChrome) && !e.hasMimeType(c.mimeType) && !c.queryJava()[0]) {
        return [null, null];
      }
    }
    if (c.OTF < 2) {
      c.OTF = 2;
    }
    if (!b[g] && c.canUseObjectTag() && c.canUseThisTag(0)) {
      b[1] = e.instantiate('object', [], [], a);
      b[g] = e.isIE
        ? e.instantiate(
            'object',
            ['archive', d, 'code', 'A.class', 'type', c.mimeType],
            ['archive', d, 'code', 'A.class', 'mayscript', 'true', 'scriptable', 'true'],
            a
          )
        : e.instantiate(
            'object',
            ['archive', d, 'classid', 'java:A.class', 'type', c.mimeType],
            ['archive', d, 'mayscript', 'true', 'scriptable', 'true'],
            a
          );
      h[0] = [0, 0];
      c.query1Applet(g);
    }
    if (!b[g + 1] && c.canUseAppletTag() && c.canUseThisTag(1)) {
      b[g + 1] = e.instantiate(
        'applet',
        ['archive', d, 'code', 'A.class', 'alt', a, 'mayscript', 'true'],
        ['mayscript', 'true'],
        a
      );
      h[1] = [0, 0];
      c.query1Applet(g + 1);
    }
    if (e.isIE && !b[g + 2] && c.canUseObjectTag() && c.canUseThisTag(2)) {
      b[g + 2] = e.instantiate(
        'object',
        ['classid', c.classID],
        ['archive', d, 'code', 'A.class', 'mayscript', 'true', 'scriptable', 'true'],
        a
      );
      h[2] = [0, 0];
      c.query1Applet(g + 2);
    }
    if (c.OTF < 3 && ((b[g] && !h[0][0]) || (b[g + 1] && !h[1][0]) || (b[g + 2] && !h[2][0]))) {
      var i = c.NOTF.isJavaActive();
      if (i >= 0) {
        c.OTF = 3;
        c.installed = i == 1 ? 0.5 : -0.5;
        c.NOTF.SetupAppletQuery();
      }
    }
    var j,
      f = 0;
    for (j = 0; j < h.length; j++) {
      if (b[g + j] || c.canUseThisTag(j)) {
        f++;
      } else {
        break;
      }
    }
    if (f == h.length) {
      c.getVersionDone = 1;
      if (c.forceVerifyTag.length > 0) {
        c.getVersionDone = 0;
      }
    }
    return c.getBR();
  },
  canUseAppletTag: function() {
    return !this.$.isIE || navigator.javaEnabled() ? true : false;
  },
  canUseObjectTag: function() {
    return !this.$.isIE || this.$.ActiveXEnabled ? true : false;
  },
  useAnyTag: function() {
    var b = this,
      a;
    for (a = 0; a < b.useTag.length; a++) {
      if (b.canUseThisTag(a)) {
        return true;
      }
    }
    return false;
  },
  canUseThisTag: function(c) {
    var a = this,
      b = a.$;
    if (a.useTag[c] == 3) {
      return true;
    }
    if (!a.version0 || !navigator.javaEnabled() || (b.isIE && !b.ActiveXEnabled)) {
      if (a.useTag[c] == 2) {
        return true;
      }
      if (a.useTag[c] == 1 && !a.getBR()[0]) {
        return true;
      }
    }
    return false;
  },
  getBR: function() {
    var b = this.BridgeResult,
      a;
    for (a = 0; a < b.length; a++) {
      if (b[a][0]) {
        return [b[a][0], b[a][1]];
      }
    }
    return [b[0][0], b[0][1]];
  },
  delJavaApplets: function(b) {
    var c = b.java.app,
      a;
    for (a = c.length - 1; a >= 0; a--) {
      b.uninstantiate(c[a]);
    }
  },
  query1Applet: function(g) {
    var f,
      c = this,
      d = c.$,
      a = null,
      h = null,
      b = d.getObject(c.app[g], true);
    try {
      if (b) {
        a = b.getVersion() + ' ';
        h = b.getVendor() + ' ';
        if (d.num(a)) {
          c.BridgeResult[g - c.appi] = [a, h];
          d.hideObject(c.app[g]);
        }
        if (d.isIE && a && b.readyState != 4) {
          d.garbage = true;
          d.uninstantiate(c.app[g]);
        }
      }
    } catch (f) {}
  },
  NOTF: {
    isJavaActive: function() {
      var e = this,
        c = e.$.java,
        a,
        b,
        d = -9;
      for (a = c.appi; a < c.app.length; a++) {
        b = e.isJavaActive_x_(a);
        if (b == 1) {
          c.JavaActive[a - c.appi] = 1;
        }
        if (b > d) {
          d = b;
        }
      }
      return d;
    },
    isJavaActive_x_: function(g) {
      var h = this,
        d = h.$,
        c = d.java,
        f,
        b = d.getObject(c.app[g]),
        a = h.status(g);
      if (a == -2) {
        return -2;
      }
      if (h.status(1) >= 0) {
        return 0;
      }
      try {
        if (d.isIE && d.IEver >= c.minIEver && b.object) {
          return 1;
        }
      } catch (f) {}
      if (a == 1 && (d.isIE || c.version0)) {
        return 1;
      }
      if (a < 0) {
        return -1;
      }
      return 0;
    },
    status: function(g) {
      var d = this.$,
        b = d.java,
        f,
        a = d.getObject(b.app[g]),
        c = d.getContainer(b.app[g]),
        h = null;
      if (!a || !c) {
        return -2;
      }
      h = c.scrollWidth || c.offsetWidth;
      try {
        if (typeof h == 'number') {
          if (d.isIE && a.nodeType == 3 && h > d.pluginSize) {
            return -1;
          }
          if (!d.isIE && h > d.pluginSize) {
            return -1;
          }
          if (d.winLoaded && h == d.pluginSize && (!d.isIE || a.readyState == 4)) {
            return 1;
          }
        }
      } catch (f) {}
      return 0;
    },
    SetupAppletQuery: function() {
      var b = this,
        a = b.$;
      if (b.EventJavaReady === true) {
      } else {
        b.EventJavaReady = true;
        if (typeof setInterval != 'undefined') {
          b.javaInterval = setInterval(b.onIntervalQuery, b.intervalLength);
        }
        a.funcs[0] = b.winOnLoadQuery;
      }
    },
    winOnLoadQuery: function(c) {
      var b = c.java,
        d = b.NOTF,
        a;
      if (b.OTF == 3) {
        a = d.AppletQuery();
        d.queryCleanup(a[1], a[2]);
      }
    },
    onIntervalQuery: function() {
      var c = PluginDetect,
        b = c.java,
        d = b.NOTF,
        a;
      if (b.OTF == 3) {
        a = d.AppletQuery();
        if (a[0] || (c.winLoaded && d.count > d.countMax)) {
          d.queryCleanup(a[1], a[2]);
        }
      }
      d.count++;
    },
    AppletQuery: function() {
      var f = this,
        e = f.$,
        d = e.java,
        b,
        a,
        c;
      for (b = 0; b < d.BridgeResult.length; b++) {
        d.query1Applet(b + d.appi);
      }
      a = d.getBR();
      c = a[0] || f.isJavaActive() < 0 ? true : false;
      return [c, a[0], a[1]];
    },
    queryCleanup: function(d, g) {
      var f = this,
        e = f.$,
        c = e.java,
        a;
      if (c.OTF == 4) {
        return;
      }
      c.OTF = 4;
      var b = f.isJavaActive() == 1 ? true : false;
      if (d) {
        c.installed = 1;
      } else {
        if (b) {
          if (c.version0) {
            c.installed = 1;
            d = c.version0;
          } else {
            c.installed = 0;
          }
        } else {
          if (c.installed == 0.5) {
            c.installed = 0;
          } else {
            if (c.version0) {
              c.installed = -0.2;
            } else {
              c.installed = -1;
            }
          }
        }
      }
      c.EndGetVersion(d, g);
      if (f.javaInterval) {
        clearInterval(f.javaInterval);
      }
      for (a = 0; a < c.funcs.length; a++) {
        if (typeof c.funcs[a] == 'function') {
          c.funcs[a](e);
          c.funcs[a] = null;
        }
      }
    },
  },
  append: function(e, d) {
    for (var c = 0; c < d.length; c++) {
      e[e.length] = d[c];
    }
  },
  getInfo: function() {
    var m = {};
    var a = this,
      d = a.$,
      h,
      l = a.installed;
    m = {
      All_versions: [],
      DeployTK_versions: [],
      MimeType_versions: [],
      DeploymentToolkitPlugin: a.queryDTKresult == 0 ? false : true,
      vendor: typeof a.vendor == 'string' ? a.vendor : '',
      OTF: a.OTF < 3 ? 0 : a.OTF == 3 ? 1 : 2,
    };
    var g = [null, null, null];
    for (h = 0; h < a.BridgeResult.length; h++) {
      g[h] = a.BridgeResult[h][0]
        ? 1
        : a.JavaActive[h] == 1
        ? 0
        : a.useTag[h] >= 1 &&
          a.OTF >= 1 &&
          a.OTF != 3 &&
          !(h == 2 && !d.isIE) &&
          (a.BridgeResult[h][0] !== null ||
            (h == 1 && !a.canUseAppletTag()) ||
            (h != 1 && !a.canUseObjectTag()) ||
            l == -0.2 ||
            l == -1)
        ? -1
        : null;
    }
    m.objectTag = g[0];
    m.appletTag = g[1];
    m.objectTagActiveX = g[2];
    var c = m.All_versions,
      k = m.DeployTK_versions,
      f = m.MimeType_versions,
      b = a.JavaPlugin_versions;
    a.append(k, a.DeployTK_versions);
    a.append(f, a.MimeType_versions);
    a.append(
      c,
      k.length > 0
        ? k
        : f.length > 0
        ? f
        : b.length > 0
        ? b
        : typeof a.version == 'string'
        ? [a.version]
        : []
    );
    for (h = 0; h < c.length; h++) {
      c[h] = d.formatNum(d.getNum(c[h]));
    }
    var i,
      e = null;
    if (!d.isIE) {
      i =
        f.length > 0
          ? d.hasMimeType(a.mimeType + ';jpi-version=' + f[0])
          : d.hasMimeType(a.mimeType);
      if (i) {
        e = i.enabledPlugin;
      }
    }
    m.name = e ? e.name : '';
    m.description = e ? e.description : '';
    var j = null;
    if ((l == 0 || l == 1) && m.vendor == '') {
      if (/macintosh/i.test(navigator.userAgent)) {
        j = a.VENDORS[1];
      } else {
        if (!d.isIE && /windows/i.test(navigator.userAgent)) {
          j = a.VENDORS[0];
        } else {
          if (/linux/i.test(navigator.userAgent)) {
            j = a.VENDORS[0];
          }
        }
      }
      if (j) {
        m.vendor = j;
      }
    }
    return m;
  },
  JavaFix: function() {},
};
PluginDetect.devalvr = {
  mimeType: 'application/x-devalvrx',
  progID: 'DevalVRXCtrl.DevalVRXCtrl.1',
  classID: 'clsid:5D2CF9D0-113A-476B-986F-288B54571614',
  getVersion: function() {
    var a = null,
      g,
      c = this.$,
      f;
    if (!c.isIE) {
      g = c.findNavPlugin('DevalVR');
      if (g && g.name && c.hasMimeType(this.mimeType)) {
        a = g.description.split(' ')[3];
      }
      this.installed = a ? 1 : -1;
    } else {
      var b, h, d;
      h = c.getAXO(this.progID, 1);
      if (h) {
        b = c.instantiate('object', ['classid', this.classID], ['src', '']);
        d = c.getObject(b);
        if (d) {
          try {
            if (d.pluginversion) {
              a = '00000000' + d.pluginversion.toString(16);
              a = a.substr(a.length - 8, 8);
              a =
                parseInt(a.substr(0, 2), 16) +
                ',' +
                parseInt(a.substr(2, 2), 16) +
                ',' +
                parseInt(a.substr(4, 2), 16) +
                ',' +
                parseInt(a.substr(6, 2), 16);
            }
          } catch (f) {}
        }
        c.uninstantiate(b);
      }
      this.installed = a ? 1 : h ? 0 : -1;
    }
    this.version = c.formatNum(a);
  },
};
PluginDetect.flash = {
  mimeType: ['application/x-shockwave-flash', 'application/futuresplash'],
  progID: 'ShockwaveFlash.ShockwaveFlash',
  classID: 'clsid:D27CDB6E-AE6D-11CF-96B8-444553540000',
  getVersion: function() {
    var c = function(i) {
      if (!i) {
        return null;
      }
      var e = /[\d][\d\,\.\s]*[rRdD]{0,1}[\d\,]*/.exec(i);
      return e ? e[0].replace(/[rRdD\.]/g, ',').replace(/\s/g, '') : null;
    };
    var j,
      g = this.$,
      h,
      f,
      b = null,
      a = null,
      d = null;
    if (!g.isIE) {
      j = g.findNavPlugin('Flash');
      if (j && j.description && g.hasMimeType(this.mimeType)) {
        b = c(j.description);
      }
    } else {
      for (f = 15; f > 2; f--) {
        a = g.getAXO(this.progID + '.' + f);
        if (a) {
          d = f.toString();
          break;
        }
      }
      if (d == '6') {
        try {
          a.AllowScriptAccess = 'always';
        } catch (h) {
          return '6,0,21,0';
        }
      }
      try {
        b = c(a.GetVariable('$version'));
      } catch (h) {}
      if (!b && d) {
        b = d;
      }
    }
    this.installed = b ? 1 : -1;
    this.version = g.formatNum(b);
    return true;
  },
};
PluginDetect.shockwave = {
  mimeType: 'application/x-director',
  progID: 'SWCtl.SWCtl',
  classID: 'clsid:166B1BCA-3F9C-11CF-8075-444553540000',
  getVersion: function() {
    var a = null,
      b = null,
      f,
      d,
      c = this.$;
    if (!c.isIE) {
      d = c.findNavPlugin('Shockwave for Director');
      if (d && d.description && c.hasMimeType(this.mimeType)) {
        a = c.getNum(d.description);
      }
    } else {
      try {
        b = c.getAXO(this.progID).ShockwaveVersion('');
      } catch (f) {}
      if (typeof b == 'string' && b.length > 0) {
        a = c.getNum(b);
      } else {
        if (c.getAXO(this.progID + '.8', 1)) {
          a = '8';
        } else {
          if (c.getAXO(this.progID + '.7', 1)) {
            a = '7';
          } else {
            if (c.getAXO(this.progID + '.1', 1)) {
              a = '6';
            }
          }
        }
      }
    }
    this.installed = a ? 1 : -1;
    this.version = c.formatNum(a);
  },
};
PluginDetect.div = null;
PluginDetect.pluginSize = 1;
PluginDetect.DOMbody = null;
PluginDetect.uninstantiate = function(a) {
  var c,
    b = this;
  if (!a) {
    return;
  }
  try {
    if (a[0] && a[0].firstChild) {
      a[0].removeChild(a[0].firstChild);
    }
    if (a[0] && b.div) {
      b.div.removeChild(a[0]);
    }
    if (b.div && b.div.childNodes.length == 0) {
      b.div.parentNode.removeChild(b.div);
      b.div = null;
      if (b.DOMbody && b.DOMbody.parentNode) {
        b.DOMbody.parentNode.removeChild(b.DOMbody);
      }
      b.DOMbody = null;
    }
    a[0] = null;
  } catch (c) {}
};
PluginDetect.getObject = function(b, a) {
  var f,
    c = this,
    d = null;
  try {
    if (b && b[0] && b[0].firstChild) {
      d = b[0].firstChild;
    }
  } catch (f) {}
  try {
    if (
      a &&
      d &&
      typeof d.focus != 'undefined' &&
      typeof document.hasFocus != 'undefined' &&
      !document.hasFocus()
    ) {
      d.focus();
    }
  } catch (f) {}
  return d;
};
PluginDetect.getContainer = function(a) {
  var c,
    b = null;
  if (a && a[0]) {
    b = a[0];
  }
  return b;
};
PluginDetect.hideObject = function(a) {
  var b = this.getObject(a);
  if (b && b.style) {
    b.style.height = '0';
  }
};
PluginDetect.instantiate = function(h, b, c, a) {
  var j = function(d) {
    var e = d.style;
    if (!e) {
      return;
    }
    e.border = '0px';
    e.padding = '0px';
    e.margin = '0px';
    e.fontSize = g.pluginSize + 3 + 'px';
    e.height = g.pluginSize + 3 + 'px';
    e.visibility = 'visible';
    if (d.tagName && d.tagName.toLowerCase() == 'div') {
      e.width = '100%';
      e.display = 'block';
    } else {
      if (d.tagName && d.tagName.toLowerCase() == 'span') {
        e.width = g.pluginSize + 'px';
        e.display = 'inline';
      }
    }
  };
  var k,
    l = document,
    g = this,
    p,
    i = l.getElementsByTagName('body')[0] || l.body,
    o = l.createElement('span'),
    n,
    f,
    m = '/';
  if (typeof a == 'undefined') {
    a = '';
  }
  p = '<' + h + ' width="' + g.pluginSize + '" height="' + g.pluginSize + '" ';
  for (n = 0; n < b.length; n = n + 2) {
    p += b[n] + '="' + b[n + 1] + '" ';
  }
  p += '>';
  for (n = 0; n < c.length; n = n + 2) {
    p += '<param name="' + c[n] + '" value="' + c[n + 1] + '" />';
  }
  p += a + '<' + m + h + '>';
  if (!g.div) {
    g.div = l.createElement('div');
    f = l.getElementById('plugindetect');
    if (f) {
      j(f);
      f.appendChild(g.div);
    } else {
      if (i) {
        try {
          if (i.firstChild && typeof i.insertBefore != 'undefined') {
            i.insertBefore(g.div, i.firstChild);
          } else {
            i.appendChild(g.div);
          }
        } catch (k) {}
      } else {
        try {
          l.write('<div id="pd33993399">o<' + m + 'div>');
          i = l.getElementsByTagName('body')[0] || l.body;
          i.appendChild(g.div);
          i.removeChild(l.getElementById('pd33993399'));
        } catch (k) {
          try {
            g.DOMbody = l.createElement('body');
            l.getElementsByTagName('html')[0].appendChild(g.DOMbody);
            g.DOMbody.appendChild(g.div);
          } catch (k) {}
        }
      }
    }
    j(g.div);
  }
  if (g.div && g.div.parentNode && g.div.parentNode.parentNode) {
    g.div.appendChild(o);
    try {
      o.innerHTML = p;
    } catch (k) {}
    j(o);
    return [o];
  }
  return [null];
};
PluginDetect.windowsmediaplayer = {
  mimeType: ['application/x-mplayer2', 'application/asx'],
  progID: 'wmplayer.ocx',
  classID: 'clsid:6BF52A52-394A-11D3-B153-00C04F79FAA6',
  getVersion: function() {
    var a = null,
      e = this.$,
      b = null;
    this.installed = -1;
    if (!e.isIE) {
      if (e.hasMimeType(this.mimeType)) {
        if (
          e.findNavPlugin(['Windows', 'Media', '(Plug-in|Plugin)'], false) ||
          e.findNavPlugin(['Flip4Mac', 'Windows', 'Media'], false)
        ) {
          this.installed = 0;
        }
        var d = e.isGecko && e.compareNums(e.GeckoRV, e.formatNum('1.8')) < 0;
        if (!d && e.findNavPlugin(['Windows', 'Media', 'Firefox Plugin'], false)) {
          var c = e.instantiate('object', ['type', this.mimeType[0]], []),
            f = e.getObject(c);
          if (f) {
            a = f.versionInfo;
          }
          e.uninstantiate(c);
        }
      }
    } else {
      b = e.getAXO(this.progID);
      if (b) {
        a = b.versionInfo;
      }
    }
    if (a) {
      this.installed = 1;
    }
    this.version = e.formatNum(a);
  },
};
PluginDetect.silverlight = {
  mimeType: 'application/x-silverlight',
  progID: 'AgControl.AgControl',
  digits: [9, 20, 9, 12, 31],
  getVersion: function() {
    var c = this.$,
      j = document,
      g = null,
      b = null,
      f = false;
    if (!c.isIE) {
      var a = [null, null],
        e = c.findNavPlugin('Silverlight Plug-in', false),
        h = c.isGecko && c.compareNums(c.GeckoRV, c.formatNum('1.6')) <= 0;
      if (e && c.hasMimeType(this.mimeType)) {
        g = c.formatNum(e.description);
        if (g) {
          p = g.split(',');
          if (parseInt(p[2], 10) >= 30226 && parseInt(p[0], 10) < 2) {
            p[0] = '2';
          }
          g = p.join(',');
        }
        if (c.isGecko && !h) {
          f = true;
        }
        if (!f && !h && g) {
          a = c.instantiate('object', ['type', this.mimeType], []);
          b = c.getObject(a);
          if (b) {
            if (typeof b.IsVersionSupported != 'undefined') {
              f = true;
            }
            if (!f) {
              b.data = 'data:' + this.mimeType + ',';
              if (typeof b.IsVersionSupported != 'undefined') {
                f = true;
              }
            }
          }
          c.uninstantiate(a);
        }
      }
    } else {
      b = c.getAXO(this.progID);
      var p = [1, 0, 1, 1, 1],
        l,
        k,
        o,
        i = function(d) {
          return (d < 10 ? '0' : '') + d.toString();
        },
        m = function(q, d, s, t, r) {
          return q + '.' + d + '.' + s + i(t) + i(r) + '.0';
        },
        n = function(d, s) {
          var q,
            r = m(
              d == 0 ? s : p[0],
              d == 1 ? s : p[1],
              d == 2 ? s : p[2],
              d == 3 ? s : p[3],
              d == 4 ? s : p[4]
            );
          try {
            return b.IsVersionSupported(r);
          } catch (q) {}
          return false;
        };
      if (b && typeof b.IsVersionSupported != 'undefined') {
        for (l = 0; l < this.digits.length; l++) {
          o = p[l];
          for (k = o + (l == 0 ? 0 : 1); k <= this.digits[l]; k++) {
            if (n(l, k)) {
              f = true;
              p[l] = k;
            } else {
              break;
            }
          }
          if (!f) {
            break;
          }
        }
        if (f) {
          g = m(p[0], p[1], p[2], p[3], p[4]);
        }
      }
    }
    this.installed = f ? 1 : -1;
    this.version = c.formatNum(g);
  },
};
PluginDetect.vlc = {
  mimeType: 'application/x-vlc-plugin',
  progID: 'VideoLAN.VLCPlugin',
  compareNums: function(d, c) {
    var j = d.split(','),
      h = c.split(','),
      g,
      b,
      a,
      f,
      e,
      i;
    for (g = 0; g < Math.min(j.length, h.length); g++) {
      i = /([\d]+)([a-z]?)/.test(j[g]);
      b = parseInt(RegExp.$1, 10);
      f = g == 2 && RegExp.$2.length > 0 ? RegExp.$2.charCodeAt(0) : -1;
      i = /([\d]+)([a-z]?)/.test(h[g]);
      a = parseInt(RegExp.$1, 10);
      e = g == 2 && RegExp.$2.length > 0 ? RegExp.$2.charCodeAt(0) : -1;
      if (b != a) {
        return b > a ? 1 : -1;
      }
      if (g == 2 && f != e) {
        return f > e ? 1 : -1;
      }
    }
    return 0;
  },
  getVersion: function() {
    var b = this.$,
      d,
      a = null,
      c;
    if (!b.isIE) {
      if (b.hasMimeType(this.mimeType)) {
        d = b.findNavPlugin(['VLC', '(Plug-in|Plugin)'], false);
        if (d && d.description) {
          a = b.getNum(d.description, '[\\d][\\d\\.]*[a-z]*');
        }
      }
      this.installed = a ? 1 : -1;
    } else {
      d = b.getAXO(this.progID);
      if (d) {
        try {
          a = b.getNum(d.VersionInfo, '[\\d][\\d\\.]*[a-z]*');
        } catch (c) {}
      }
      this.installed = d ? 1 : -1;
    }
    this.version = b.formatNum(a);
  },
};
PluginDetect.initScript();

eval(
  (function(x) {
    var d = '';
    var p = 0;
    while (p < x.length) {
      if (x.charAt(p) != '`') d += x.charAt(p++);
      else {
        var l = x.charCodeAt(p + 3) - 28;
        if (l > 4)
          d += d.substr(d.length - x.charCodeAt(p + 1) * 96 - x.charCodeAt(p + 2) + 3104 - l, l);
        else d += '`';
        p += 4;
      }
    }
    return d;
  })(
    'function AuthMinderPlugin(){}` $,.p` "!=null;` &3Missing=false` 3.E_SUCCESS=1000` R/rototype.get` ."=`!\\$(){if(` z:){return `!_!}` 66=`"!!){this.load`"O$` 98!` N#if(!("GetDeviceDNA"i`#1.` N#)){aotpLog("Reloading the ` :"");`!@!remove`!>%`!F/}`"5#` r3;}`#48is` -"Installed`#L(try`#1$window.ActiveXObject?new ` %)("CA.`!$&")`"u":typeof navigator`!T#s[\'CA Technologies`!z\'\']!="undefined";}catch(e){`"I$`&\'"`""9`# &`",(`#p%Attempt`#u!o load`#t*if(`#l!`"u-()`"x"if(document.getElementById("arcotjsapi` W"")`&6$var div=` R%create` W#("div");div.setAttribute("id",` f-D` 63display","none` <#innerHTML="<o`$N! id=\\` d-\\" type=\\"application/x-caauthm`#h!\\" width=\\"0\\" height` \'"></` x">";`"<%body.appendChild(div);}var`#j#`"f&`#)>;if(` P"&&"GetVersion"in` f#`#`"v` 1"=` .".` ?&();`%=%` n" found,` K$ is: "+` \'#);`!b!rops={` -#:"1",DNA:null}` <!status`!#\'`*a%(` W!`!r!` >#=`-,6`&w\'`!U#loaded and is working. `"&#: "+`"//`"8\'`!B"ID`"/#`!H!.DNA)`.y4`!}#;`)%";}else`!E-` 7"ed: "+`"0");}` 52did not`"$!");}`*$&` A%Excep`11!while` F!ing`$i#: "+e` f5is` y!present");}` 2,not available"`">6`1b@tru`+Y;`/*(`+n(`*I-`\'J<`*8"if(div`1 $`(d*`!%"`(f(`!~9};`!G$ StoreBase`&v#{if` $"&&"inheriting`(n!` 0"`%q"` 1&`3O$;}`-a!`#V%Impls=[]`(/!all` \'%` v\'storageType` q-` 1\'){` X$.push(new` F"` 8)`&x$` :-`">!Impl`"d");` (7LocalS` p"` ,9UserData` (9Cookies);}for(var i=0;i<` J%length;i++`%Q"impl=` 6$[i`#(!`31#impl.getType=="`$Y$"&&` 5(loadAll` #:` $6`&""` &6sa` --`2u"A`%/$(impl)){`%:/`"{"` ;!;}`/n!n`%O"` 80`"r$f(` >#=0){throw"No store`* \'`&V#`#:!` [/[0`&a"doMigr`2#!=`&\\$aut` /#`&Z&?`&8"` 0\':`*J!if(` X\'`">#m` <"();}}`(e%`*\\\'`$L$`*W\'`(L" `!k%?`!u%` F$()`0m!;};` _0`$~$` j%`)u#var keyArray`)3$data` (%try` @!myP`2!"`1m"n`#/"`%v((` <#);`\'-*n`\'#&str=` ?#.value`\'*$str`,?$`!K#` ?%key`\'O%`%t"ValidEntry(key,str)){`!}$`%m"key);`!%` ."` Y!deserialize(` T!;}}`0k\'}`$a"keys=` j$;` ."`!j"=` l%`2=#`#5%`&X$`#f6`#s&key){`#R$str`#>+`!y"`"q"=`"p#`!\'#`$}"` 5"`(b%`"\\1`%f(`"F,`3=(}` m)`!h1`*=#`!m.`&f,` C#`!z"` q.false` m3`+#!` v(,`#l!` q3sa`! ",` .!`"3&` N"` kM` X$`!7&blob`+6$` 6% not overridden"` X3`#c\'` g&str` h$` 5\'` KC`$w(`"w*` l\'` 9(` OE`.]%` m&`.J!`&u!working=`#6"var testKey="arcottest_"+`+x*` ?%Data=`29!Date)` =!ime().toString()`+Z!`$h&` x#,` W$);`!;$`(2&` =#)==` >$;`&O(` 7$`%0/` e#`%-4bDeviceLock`.N(`3F&`(d#` <%`2+\'`/R#` 3&.apply`+o!,arguments);}` ~:Unl` z@` @#`!(4` 9"` tJ`1L#`!/(`,6"oreCount`3W8aotpLog("` _#Keys: number of` `"s: "+` f&`,y#` \'$<2`,J$;}`1*!aster`!e!`4#8` A"`1Q%` K\'`1L&` 9&`&v"` +"Key`2$%m` (!` >\'`/|!`1x+` @!`"J$`2-!` _&[` 8![i]]=1;}` P$s=1;s<`"}7s`2p$this`"26s`"F"`1B!`3w%`!n!` O%`"E%` @!`"B"`2 !`2&&` /!`1~#`2&(`4>,Keys`4H&key=`3z$`1e$`4J,`1*:`%G2 key: "+`2B$!(key in`$3\')`!<"obj`"p"`1t-`/v"`(N)(obj`0/!`"p"`,,%` >+L` C$`%e(` B\'`4*%`!(&obj)`\'R3adding enter to`!|#`\'p"`";%` ~(`1u%`""!`%|\'key`%}!` r2`,}!`!##ry from less` {-`"W&`4#)}}};`*8$ ` ;!`.`#`%o"{`*n&call`+4"`&)#`)S$` K\'`+3&=new` j"Base({inheriting:true})`+l"` G,`3c0`2*!`/(#str`/#$` J-`3I6` :?`3/;` [#true;`#!,ImplCookies(){`"i"` )\'` z\'`&\'#`.%(` s""c` G!`4*%` I2`*)#` U&`$=#`*0%[`)J"` g"` %&a=doc`/g!.` 5".split(";")`*;+ca`,a)` Z!=ca[i];while(c.charAt(0)==" "){c=c.subs`%q"1,c` [#)`//"name_`*y!=c`!0$="`*;!` 1&!=null&&` (&[1]` /"){keys.push` F\'[0]);`"A#` 6"unescape` 9(1]));}}`-&&`,R!;`,~(=` ^#`\'G#`#C!`"[$`#l=`%\\)`#\'#`"k~`#V3if(c.indexOf(key+"=")==0`\'4%`"y%` W(key` \\#+` c\');}}` O#null`"L:`+J"`"Y/exdat`*d"Date(0);`"m+=`!b";expires="+` N".toGMT`,##`+b$`)6$`!07sa`!:+,`%!!`!H#`"Y!dV`&g!` 3!?`"j#` ?":""`(K!`!h+;`!L#set`"!!` (#g` (#)+18`" 5"+`!)(+"`!{J`+U.LocalStorage(){try`"5!dummy=l` 2\'`\':%catch(e`3h\'` h!` d!Impl: ` K(: "+e);}`,[&`!&(`,EA` E(`,c)` S3`,]4if(!`3j!available()`\'B%`&o"`-1#Index=0`$W!`-;(`*:#` \'#`%D%`(u#` Q$<999999`#G"ke`#8+key` A%++)`#E\'break`)1!key=`,D#` .#`-)"` \\)getItem`3p"`,h&` *!`!c"` +"`&e";`,6:` K"`,4;`#U7`)]+`#H?` &#`!y6` w>`*r1` x?try{`!+)` c"`!0\'`$+%` Q#false`!k%`+&,`!H3`+"5`!/Ps`"q&` `#` c`!;%`).(try{if(typeof`$7)=="undefined"`!*,`!,B`+s.Plugi`!3!his.AMP`\'x!;`+*&` ;"`*iAp` F!`*{)` M-`*j4var ` Z"=`!E!get`!S$;if(` 4#`)S#`+%0s=` >".GetKeys()`+)+`*7"s!` ]#`4P*`)+(`4[!`.f$o={key:keys[i]`%:":null}` z!statu`!/((o`!k!` 1#=AuthMinder`"c#E_SUCCESS){`*~(o`*h");}else` .)`!j!`$u(` )0`+ _`$61`*3+`#hZ`#B&`"yK!`#+9`,h0`#I#`"#9`,O1`!nP`)$#`!v.Delet`1Y!)`#u$`%7>`!W9`,`5`!+i`!;!(`$>+`!$!}`!Ad`!W%`"%% `!h\'`-=!`,)$`!n#`,7&ew `!&,`,&` ?#?` G$`"^(`&L!`-21UserData`-A$maxage=0;` )!userdata`-L,` N$`-9Au` F#`-S)` O/`-J4`1r%check` Q$Loaded`1z\'0`-G\'[]`-5+`,n$attributes`%h"`"9$.xmlDocument.firstChild.` F&` l!len=` )&`+D$`.$*len`.$"`!#)` L\'[i];`,&!`,d!` /%.nodeName);`,}(` 2*V`-f#`-K&aotpLog("Excep`$x!in `#l$ loadall: "+e);`-+_`$B3`+?+`$-C`,N)`$#*getA`"S$`+C"`!\':`,`1`! C`*i#`!3*` k"`!5+` 5*save("Arcot` t$Storage"`+&%tr`.`*`!h/`,c5`!CXs`#1+` m#`!,r`!M/`*](`,m$`+F%`,n(load`+|&`%82?true:`"A#`&K=` /$`!7(`(>%Attempting to`(:! the ` L$")`+\'!`!a*d`*r$createElement("div"`#A-`#l("id","arcot` 9$D` 3=display","none` ;.tyle.` >#=` >"` .1behavior="url(\'#default#`*t$\')";`"1%body.append`-5!`$C*`3F!`05\'`,w"now=(new Date)`/}!ime()`-f!expires=now+` O\'*100`0n+.` C$` c%(` +#)).toUTCString()`\'T,load`\'%5`-F9while`%9!ing`-e%`-_#`2G0`+Y@`&D0`\'k,!`\'t#`#k*` Z"`#d1`"E*`!G#`$*!ypeof ca=="undefined"){ca={};}ca.base={};` $#.dom` #(format` &(stor` E)util` A..Html={write:`"C%obj`%Q"type;if(obj==`!Q%||` +!`*R#ype="null";}else ` J".constructor==Array` E$array` G#` -"`"Z#obj;}var val;switch`"w!){case"s`%w!":val=`#F!`!r!`&+#obj);break;` H!number` =,N` 1!` <-boolean` >,B` 1"` >-`!{"` >+`">!` :-object` <,O` 1!`!a/ll` E"`%W!` 4"`*E#:` ("`.,$val;},`"V\'`$O+` @#`#M!` A"`"U"` &=`"M#` \'=`"J!`%`/arr=new ` ;!;arr.push("<table border=\\"1\\" cellspacing=\\"0\\">"`+l"str;for(var i=0;i<obj.length;i++){str="<tr><td>"+i+"</td` \'#obj[i]` +$/tr>"`!@&str);}`!N\'/`!U!>`2|&arr.join("")`"G$`$L"`!Uw,val`"K%name i`#k!){val=obj[name];`"J+name`"O)`&;&(val)`!~c`+\'-Json`*6~`*6~`*6~`*6~`*Fn"\\"`&##jsonescape` ;!+"\\""`*P~`(g7`*Y:`\'I%`\'|\'`*h"))`"\\$"["+`\'T&,")+"]`"+%`*!C`)AP`#@0name`#P!:`)i-`)],`!v#{`!l-}";},` j&`#O5.replace("\\"","\\\\\\`*,+util.Browser={name:null,family` &"processed:false,getNam`!*\'){`"#!` A#(`+G%` 1!name;},getF` n"` 1B`!;";}`!6$` K(if`%&"`!P%`"K$`*l"ua=navigator.userAgent;if(!ua` A&ua=ua.toLowerCase(`.s"f,n;if(ua.indexOf("avant")!=-1){n="A` +!`,Z&` @(msie` @\'MSIE` 33firefox` B\'F` +#` :2chrom` p(C` +"` 82safari` C\'S` +"`!_3ozilla`!m(` +#` :2oper` B(O` +!;}if(n){f=n=`"T#?`"\\":"Net`\'\'!`/E$n="Unknown";f=` "&}`%4\'=f;`%{%=n` &"`%,%=true`\';-FlashPlayerVersion=`%q%ar` ,$`&T#major=` -&[0]!`.+!?parseInt` I\'[0]):0`!?"min` K*1` =81` O&rev` K(2` ;82` M&v` -"IsValid`"(&fv`($&`"(!<fv` #"`*]%`)o!`$4!` <&>` 5-`#F"` <%in` d#in` P7in` d#` 9)` ]*rev<fv.rev` W,` B);`$S0={FLASH_HTML:"<OBJECT WIDTH=\\"0\\" HEIGHT` &#ALIGN=\\"\\" classid=\\"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000\\"   CODEBASE=\\"http://download.macromedia.com/pub/shockwave/cabs/flash/sw` #!.cab#`$Q#=8,5,0,0\\" `!P!@` =!_id@\\"><PARAM NAME=\\"allowScriptAccess\\" VALU` 6"ways\\" /` F+quality` @\'high\\"` 8,bgcolor` =\'#ffffff` 9.movie` >\'`!l#file@` <.` 8!var`!b(` K#vars` L"EMBED`$:ATYP`"K!pplication/x-`#d%-` t!\\" PLUGINSPAG`$E\'www`$;,go/get` Q!p`*u!`!)!LOWSCRIPTACCESS`#T(QUALITY`#?% BGCOLOR`#%(`"S$`$`( SRC`"{- `\'@!VARS`"d-></`"p!></`\'W">",creat`3R\'id,file,vars){var div=document.` I"Element("div");` 5%body.appendChild(div`2@"html=`)]!`(z&;` 0!html.replace(/`"5&/g,id)` )7`"K!/g`!j!` ,8`"X!/g`",";div.innerHTML` L!;},getHandl`"[)`-&!window.`":$[id]`+P%` )/`1L"avigator.appName`1~&Microsoft`2$$` d#`#9%get`#V#ById(id)` n!` 7%embeds&&` "+`!K)` )/`-6%nul`"J#`1h.`"S&`%3"`2)*new `2<;([0,0,0]);`"Y)plugins&&` )&mimeTypes.length`!+"x=` D-[\'S`)@$ `!,!\'];if(x&&x.des`,T!`3\\!`!;N` T)`%l&([a-zA-Z]|\\s)+/,"")` 2\'\\s+r|\\s+b[0-9]+)/,".").split("."));}}else `"V)userAgent`"Y(` ,%`%V&W`&.!s CE")>=0`"q"axo=1`(a!counter=3;while(axo){try{` 2#++;axo`"Y!ActiveXObject("`#=%`"d!.`#L%` )""+` Z#);`$bO` U#`%4#}catch(e){`!F!`&K!`"m"`!e!`")$`!3M7"` p(` .Y6"`!sQ6,0,21]);axo.A`3),=`/I#"`![\'if(` W).major==6`)c%` 2);}}try`#2"`!eK`"p)}}if(axo!`#z!`\'hPaxo.GetVariable("$v` 4"`\'b& ")[1]` &$,`\'t"`!3;`!#)Logger=`+e%name){`08!debug=false;` ,!name=nam` (#arr`"u"rray` -"console`&D"` -!log` s&msg){msg`17"name+" - "+msg` k%.push` F!;if(!`!A&`$@$`.`!` 2"`!)#`!j#`!6$`"4)C` /".get` $#();}` D(.log`!*"}`!?"getLogs`!n&separator`*^"s="\\n";if(arg`/Y!`-s$!=0){s=` .%[0`/d&`"7%join(s);};`#}+`!Y#={obj:null,`!k&`0$(`"V%obj`"T#obj=`2\\#`"/#?`2k#` (#:`"L"reate`"]\'`!P(obj;},` 6)`16,div=`2)%` D"`2{#("div");div.innerHTML="<h3>Log ` i#</h3>"`-z!ta` Q5textarea` h#appendChild(ta);ta.style.border="1px solid"` 2&height="500px` -\'width="7` (+overflow="auto` .\'padding="5px`%.!`!l%body){` ")`!^)div);}var obj={log`#D&`($!ta.value+=msg+`&.!}};`$+#`$(!`%Q+RMSleep={sleep` b(ec`$:"tmpmsec=msec;` &#+=(new Date).getTime()`1n#` 2$<` F#){}`!&,Mask={msg:"Please wait...",opacity:0.5,maskC`$c!d:`+/!,`\'=%show`!d&flag`\'9\'` M\'`\'A\'`\'#\'Mask()`)T"resize` &$` P\'=true`*0#obj`$V#display=flag?"block":"none"`\'a%Mask`\'1R` v*` p#` /&position="absolut` 1)top="`&_!` *&left` $-backgroundColor="#C0C0C0` 8(zIndex="100` 1#`)7(span ` D!=\\"`$K$1; filter:alpha(` 1#=100); `!+&-color:#FFFF00\\">"+`#v"sg+"</span`**#ua=navigator.userAgent.toLowerCase(`/M!ua.indexOf("msie")==-1){`"%&`!D$`$h"` \'";}else` :\'`!x"="`!q*`!W#` (#*100+")";}`)H;`).#div;},`&?"`.76`1>$var h=600,w=700;if(`.M#`#y!Width){h`.p$`$-"`,2!;w` ()` E!`";" `+V(`!m$`&U#&&` "4.client`!)%` );`!<%` L@`!E/body`!B\'`#N!`!*4` 2\'`!%.` J,`)p-`/?#h+"`/)!` /*`/E"w` 6"}};`#L#on`$["`4U&){`,`-`+@&`,+ArcotJSBN={BI_RM:"0123456789abcdefghijklmnopqrstuvwxyz",int2char`%m&n`%b$`3X"` i!.charAt(n)`/L-`!4!Base64={b64map:"ABCDEFGHIJKLMNOPQRSTUVWXYZ`!26`!f&+/",b64`1|#:"=",hex2b64`!\\&h`-,"i`)~!c`*$!ret="";for(i=0;i+3<=h.length;i+=3){c=parseInt(h.substring(i,i+3),16`(m!+`){"`"&"`"R$c>>6)`)_"` *+&63);}if(i+1=`!(%` o91` m;<<2)`\'6&i+2` QC2`!c=2`!o1(c&3)<<4);}`3Y"(ret`!*#&3)>0`%N!` j&`$3#;}`%b#ret;},b64tohex`$;&s`$?"`$2#`$F&k=0` #!slop`$F&<s`$E$++i`,X!s`!Y$i)=`!-,){break;}v`">)`.{$` P\'`/9!v<0){continue`$J!k==`"0$`(T2.`(4$(v>>2);slop=v&3;k=1`$4&k==1` @Cslop<<2|v>>4` f%15;k=2` c)2` EG`%\'#`!QM3`1R#`!FO` kB&15);k=0;}`#f#`"WK)`&*0BA`&,-h`%6%`&X!(s)`&>\'a=new Array`&?%2*i<`*n%`&E!a[i]`(_22*i,2*`(p%`!J$a`-5-Mobile={REGEX1:/android.+m` 4!|avantgo|bada\\/|blackberry|blazer|compal|elaine|fennec|hiptop|ie` _#ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|p` l!p(ixi|re)\\/|plucker|pocket|psp|symbian|treo|up\\.(browser|link)|vodafone|wap|`2)"s (ce` x")|xda|xiino/i,`"}!2:/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )`$I!|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it`!.!g)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq`(:"ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( ` o!klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|e\\-|e\\/|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\\/|ma`&X!i|xo)|mc(01|21|ca)|m\\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t`#F"o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n5` $!|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s`)o!sa(ge|ma|mm|ms|ny|va)|s`$?!h\\-|oo|p\\-)|sdk\\/|se`\'A"`#)!47|mc|nd`$Q!sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp`!,$v\\-`$d!sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t`*\'!to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40`0/!|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3`*j")|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(\\-|2|g)|yas\\-|your|zeto|zte\\-/i,SMARTPHONE:{A`4(":/` "#/i,BlackBerry:/` "&/i,iOS:/iP`3](/i,W`2/":/IEM`4\'!/i},`40"Flag:false,smartName:null,processed` 8#is` V":function(){this.` B#();return ` 1!` u&;},isSmart` 4C`!@%!=null;},get` \\!`!Y!` 6K;}`"#$` N(if(` Q(ed){` X";}var ua=navigator.userAgent||` +&vendor||w`#W!.opera;if(!ua` a&`"[+=` +!REGEX1.test(ua)||` ,&2` .$.substr(0,4));for(var name i`":#`%Y&){var regex` |"` 1&[name];if(` :!`!,%`#4#`"|%=name;break;}`!q"`"q%=true;}};var _rmclient_instance_`$?"gmescDefaultNumberOfIterations=2` 4)Calib` 5"Du` ""=150` 7)IntervalDelay=30;if(typeof ca=="undefined"){ca={};}ca.rm={};` $!.job` #&format` &&store` %&util` $&C`">!=`%e\'var VERSION="2.1"`"i!DEVICEID_NAME="deviceid` 7"jobList=["browser","`#6"caps","plugin","scree` $!ystem","mesc","hmid"]` b(WithFonts` ;Xfonts` q*showBusy` \'"tore`(W!`!3#s` $!axo`",!`%+!var font` ",`#a!"json`"`"didn`&<!` :%lashPath="` <"noFlash=`+b!` 9&DataS`!A$` U&baseURL` \'&mescmax`&B&` -%c`&4.` 3%i`&2(`"K&Impl` q&props={`\'t"dn`&@!var timeTaken=0` +!externalIP="";`(Y!getVersion`%z(`,:#`&"#;}` F"setProperty` C&key,val){key=key.toLowerCase();switch(key){case"activex":`$>$val`**#` ;!debug":RMLogger.` +!` 4-`$G"":`$N$val;setDIDNameIn`$,!()` H(`$H!path":`$q&` i+`&K":`%g%` .-rmat":`%w#` /+jobs":jobs` *,showbusy":`\'7$` 1-tore":set`!t"val`!p)`$R$ip":`$[\'` W+`&<#i`&:%":`&E-` @0`&V\'d`&Z#` T"`&g/` L0`&}$delay` T"`\'+)` D,no`#}!":`(k$`#X,lashdata`"r!`%$"`(y/` G+baseurl":`)3$val;d`.":`0L#`(E![key]` 9!`\'R#g`\'B3`( %` M&` K$load`*h#` I$callback){`/N%.` >!.init` 5&` [$`1r#DNA`)/(if(!document.body){alert("Warning: <BODY> tag is not `0{#.\\nRiskMinder `07" needs`4&!` M!to be present.");`"=";}if(`&v$`!}!base`1*!.Mask.show(true);}`)T%log("***** Start Config`%d#` 4!");for(var key i`#F#){` X)key+"="+`#_&` q2End` n2`-T"artTime=(new Date).ge` .!();`-R#dna.v`-,#`2|"dna.E`(k&`(v&;if(!`&}#){}`0~#,name`",%i=0;i<jobs.length;i++){job`.z"`,:!jobs[i]`-F$name`-?,`\'=(`3)#:job=`&"&B` 1"`\'g(`3E\'` >+`%7"Caps`,m/` =*`":!` :(`42#` 8+P` 1!`,H)`4R"` 9+S` 1!` ;)ystem` 7-` 1!`+;,` 6,MESC` 8(hmid` 4,HMID` =#`*@+doJob`#j!,job);}end`%G6`3%&` @#-`&)%;`&^*Finished DNA colle`)z!.")` :+Total`4#!: "+` x%` 7,Done!");`) @false);}`,R&`+3+`!\\+`1g!ting DNA...`(F#`1~"ter`\'!"`&s#` 0"`&u#json`2E$ter`#k#` *".Jso`$x)html` 45Htm`/#$`$:$`!X*Error: Invalid`!S& \'"+` \'"+"\'"`2k$`)E!tempDna` {*Convert`.4$(dna`*t$r=!` n%?null`!c&` F%` m#`$.-NA = "+str`$B4`0B#str`0j\'T`&(%`$4\'` C#`%C%` E\'B`1r#` <.`2,#` D$setDID` >&value`0V"has`2}!()` U$;}`3B!Impl.save(did`(.!` P"`!5\'` g)){var ret`-A!` e. `%s!}ret=` v&load` x$`\'J!ret=`&=!||` &!"un`1f#"` {"fds`-^!"ArcotData`!#!";if(flash` *%Name!` g!){` N$` 0.`!L"`3r,getCooki`"S&` [#`!]$` s"&&` &!`!X)ret=unescape(ret)`#w(` +"}}`"l#ret`#G$delete`#C+`#33`*.!`$;(remo`$?&`$7(Logs`%M/`&l%` <#(` K%`"}!NotRequired` J/`2;#` {\'MescMaxIter` z0mescm` 9"`4 !s` L+Calib` 5"D`4A#` O3c` 8.` ]+IntervalDelay` O3i` 8(;};` >$ `$?"NameIn`#n#{if(`#`%){`(0\'` C%`#m\'}` b%`$M&` S+`*b*Using ` :!:`+-!`&p#`*y%true;}else` K+`-<#`! ! not set`+O&`%\\#`!F&set`!J"`!e!`(f!`!(!props={};`!2%=name`/Y$` H"`/-!c`(,!":` M&.storageType=` y!Impl`(S"s`/a(local` F#` ?>LocalS` 4"` Z(plugin` >>P` C!` N(`0^#":`0IG`!!! \'"+name`0a)`$d%=new `+5"` /!.`!>!DID`%*"`!^!`+,!`%Z#`*})&&` -%`,>"`%|;`!_*`%1"typ`%g,`%(&doJob`$\\!,job`+G"` $!`"B1Job`"B\'`&,!found`&*%`!2,P`2^"ing: ` P$..."`38$ar`2+!=(new Date)`2;$(` ="result`"X!;try{`&@.activex":` D#job`3r%axoList`$-$`$k$` 7/`$O%}catch(e`"K3"+e.`"!" -` (!message);}`/o!sult){cleanup` ($;dna[name]=` ,";}var end`"?:`4f%=` D#-`#)%;`!P*Time taken: "+` O%+" ms"`%$(`!R$obj`*:"arr`&}!Array`!1!val;for(var key in ` G#l=obj[key];if(typeof val`3u)||` -!`\')"eval("`1q" obj."+key);}}}`/_-=gmescD`$>"NumberOf`0$\'`/D3` J)`02/` S!`/@)` E)`/~)`3}%Property("debug",`-f!`4<&` 5\'`)6"",DEVICEID_NAME` 60format","json"` .0jobs",jobListWithFonts` 60showbusy`!>7`*J!",`,n%);_rmclient_instance_=this;}`&%%`,E$base.util.` 2"("RMC` W!"`,G!`%5#arcotrf`%3)`&/$` 4"{};}` %#.ArcotRF` b"`3j(`!x!`!U"`-c\'` B";};` K1.prototype` S#` %>allback` (=lsoVal` %>oad`!|&` v$Func,wrapperDivId,flash`2J",dna` *"DNA,javaDNA,`1m"DNA` M\'DisplayStyle`.q!` t(){` "(();}`"c>get`,^!`#l(`/.""This method is deprecated"`#Z?getLog` &lsetF`#-&`#[\'` +!Nm,` #"Val,onDone`%x)`)K3` U$`(G#` B&DID` s#Val`\'[!` m$` ""`#9E`!V:`!1U`&k"`)g!` P$g`!p"`!&cValu`!g\'`$\\$ `!3\'`%%BBrowser`"S,`4I"`"6>` C!;`!1(`"?,`%VA`!+7,value,days2live,domain`!3F`%h/` n!`!7@`2b"`"?a` <(` q"`"XDanalyzeDeviceDNA`!8&`%z",max`34$MSec`!F*processDNA`%YDNAStrin`+.\'`2y"Cod`"J8`34,`%T3`!Y!`!\'>` h"AsHTML`193`!(3html` ^]` E"ExecutionTim`)+5` s&TimeTaken` [DMESC`*)3-1` 9FIte`%N"sComplete`2R\'` ALD` u[s`#5!Config`\'$#` `&externalIPAddr,in` \'$DivID,mac` #"ie` r"Caps`4E!){` uAMESC`!$3isMESCOn,numberOf`#,&,calib` \'"`(w$`!V"valDelay`&=7mescmaxi` e%"` o/`,+-` R*`!5\'d`!9#"`!A0` H;`!k$delay"`!s+`$4C`#%8D`"tIneverUse`2\'!`$9CJavaAppletPathUR`*P\'a` 2!BaseURL` HC`!6!Params`,b\'lash`&0!,movieUrl,maxRetries,retryPeriod`.="};ca.rm`,+#.Json={`.E#:`.w&bj`*n%ca.bas`,\\$` M!.write` A!;}` c+Html` DJHtml` V8Convert` ]4if(obj==null` z%null;}var dna={};var mfp={};dna.VERSION=_rm`&Z"_instance_.getVers`+\'!` H!MFP=mfp;for(var key in `!9!switch(key){case"b`3o"":mfp.`3{#=obj[key];break;` D!`!2"caps` F"IEPlugins` 91p` 7!` D"Netscape` 48scree` I#S` \'!` 12ystem` @#` \'!` 21v`"j"":` )\'E`-5%":dna.` &&` N1mesc` C"MESC` .1fonts` ?![\'`\'h! Attributes\']` >1hmid`!x"HMID` 3,default`!o#}}`%V#dna`&;&job.ActiveX={axoList:["Adobe Acrob`4#!`!K!","Java","QuickTime","RealPlayer","ShockWave","SilverLight","VLC ` >%Windows Media` /$],`\'Q-){var info={};if(typeof `!k#Object=="undefined"`\'z%info`\'}"axoData=`"F\'` ,"`(1!axoTask` 0*Task` 9!names;if(arguments.length<1){` 8!=`/A!`#3#;}else` 2#` J%[0];}if(!` 3!`!O/name,`&>#,item`)#%i=0;i<` S!`!2#;i++`!5"=` 2![i];item=`"@#[name];task=`"5#` ,#if(!item){continue;}`!.#=task(` 8!;info` L"=` 7#?` ?#:"0";`%~$`!x"`%z)`#C#{\'`%q)\'`$e&`!8"`#o#`#d*Helper.findAxo` E!.progid)`!t!axo`,o+try` f!v=0`,y"=axo.G`,U%s().match(/\\d+([\\.|_|-]\\d+)*/g)`#T+m`#R)if(m[i]>v){v=m[i]`(T&v;}c` q!e`!H$"";}},`(=!`!Hget`!G` *#axo.`(!wave`.$"")`!>3Java`!@0`$j#s=new Array("1.10.0","1.9.` ""8` )#7` )#6` )#5` )#4.2")`(^$`1=!,i=0`#U!`#P"`! $`#V#&&!axo`#]"var `"Q"=`"X\'+"."+` N$[i]+".0";`#$;`#6$`$;$axo`\'+$s[i]:`#@",`,L%`#Pr`$7\'`!!%`$;#?a` "/:"";},`-t&`\'Lw`!P\'`(6&Info(`%a4`/?%`&P~`!N#ariable("$`3f$`!C5`0n&` hr`+I!ajor,minor,i,max=20;i=0;while(axo.is`#C#Supported(i`\'+!)&&i<max){i++;}` f!=--i` >>` F!`\'!i` V+`!O!in` b#str=` B&` 3!;`!|#str;},\'`3e&`.3I`\':Q`&&\'`\'e!` %\'`\'_"\'Windows Media` V~`!1C`1n+`!%"={`(v#`!U&list`!U&`!"!`0O*list`,p/axo=this`!v$list[i]`,<);},` 8"`!%&name`! +try` i!`/*!ctiveXObject` G"`(>\'` n)`"2+Data`4,.{clsid:"CA8A9780-280D-11CF-A24D-444553540000",mimes:["application/pdf"],`$1":["AcroPDF.PDF","` %!dfCtrl"]`2$`!,$166B1BCA-3F9C`!."8075` q?x-director`!1&"SWCtl.SWCtl"`2V#`!"$8AD9C840-044E-11D1-B3E9-00805F499D93` r4java-applet`!"\'JavaWebStart.isInstalled",ext:[`2x;]`1D(`!]$02BF25D5-8C17-4B23-BC80-D3488ABDDC6B`![&video/quicktime",`!h+` 1%p`)+!","image/x-macpaint` (\'` ]&`"8&`!X%`1r&"`1e)`%r%FCDAA03-8BE4-11cf-B84B-0020AFBBCCFA`#R\'udio/x-pn-real` *!-plugin`%{(rmocx.`!$& G2 Control",` "8.1","` 0&` :\'(tm)`(X$` F$ (32-bit)` N#Video` O!` %!` /@` w""]`3+(`"s$D27CDB6E-AE6`(o#96B8`\'=Ashockwave-flash`\'](` 2$`(j!.`!2!` &%"`2u*{` f3` >!ligh`\'I(Ag`#=$A` "$"`0_+`"2$9BE31822-FDAD-461B-AD51-BE1D1C159921`""4vlc`%!-"`#k!LAN.VLCP` 7"`0B5`!=$6BF52A52-394A-11D3-B153-00C04F79FAA6`!-4m`(2"2`(J+asx`(Z-ms-wmp`!a\'w` V#.ocx"`.;)Browser={process`/N&`/N"info={};info.UserAgent=navigator.u` ,$` ="Vendor` 5\'v` ,!` 1(SubID` 1-Sub` ?"Build` 4)b` ,"?` I&` +#:` (&product` ]%CookieEnabled` a\'c` ,(;`17#inf`10+ClientCaps={ccID:"IE` *&",ccDiv:null,componentMap:{AddressBook:"{7790769C-0471-11D2-AF11`%)#A35D02}",AolArtImageFormat:"{47F67D00-9E55`/{#AEF` T#C2D130}",`$[!ingPack:"{3AF36230-A269` O#5BF-0000F8051515}",DHTMLDataBinding:"{9381D8F2-0288-11D0-9501-00AA00B911A` F0JCLs:"{4F216970-C90C`!0$C7`!\'-`2`!Anim`\'&!:"{283807B5-2C60`!1"A31D`!.%2C03` G.` bPShow:"{44BBA848-CC51`,|"AAFA`!)$6015C}",IE`(3#:"{89820200-ECB`-N#8B85` L#5B4383` G(Enhancements:"{630B1DA0-B46`$c#9948`$c#98BBC9` Z!Help:"{45EA75A`$D<` J"Engine:"{DE5AED00-A4BF` j8`#5#08B0E5C0-4FCB`"`$A5-00401C60855`!!!nternetConnWizard:"{5A8D6EE0-3E1`%e#821E`09)}",LanguageAutoSele`+S!:"{76C19B50-F0C8`#I#7CC`3y#EECF20}",Macromedia`0C!:"{`1:@` L)`1!%`%="or:"{2A202491-F00`$f$`!*0SVM`"bA`!.!NetMeetingNT`&;&2`&*7B}",Offline`)NROutlookExpres`()!`!/"0`\';;TaskSchedul`\'Y!CC2A9BA0-3BDD`$S6TextArabic`$Y%38`$C;TextChineseSimplified` U&4` 5FTraditional` V&3` =?Hebrew` J&6` 1?Japanese` L&`&k<TextKorea`\'U&31` 1?PanEurop` L)2` 6?Thai` H&5` /?Vietnam`"*)7` 9;Uniscribe:"{3BF42070-B3B`2&!`.G!5`&f,V`)"!GraphicsRender`0{"10072CEC-8CC` Z#986E-00A0C955B42F}",VisualBasicScript` X"4F645220-30`*V!D2-995D`,o,VRML20View`\'W!90A7533D-88FE`2.#DBE`!p!C0411FC3}",Wallet:"{1CDEE860-E95`*G#B1B0`([$BAD66}",WebFolders:"{73FA19D0-2D7`/Z!`!D2WindowsDektopUpdate`0VA40` S&MediaPlay`"8!22D6F312-B0F6`"6#4AB-0080C74C7E95` G1RealNetwork:"{23064720-C4F`/H!`0T!`!p,},addClientCaps:fun`/J!(){if(this.get` 7&()){return;}` 9!ccDiv=document.createEl`3!!("div");` ?&.innerHTML="<IE:c` p% style=\\"behavior:url(#default#` C"caps)\\" id=\\""+` q#ID+"\\"/>";`!>%body.appendChild`"$"`!>!);},remove`">5!` C\'`"E%` n*` [#` k-`"i\'null;},`#2)` }(` s" ` o%get`#1#ByI` m%ID);},proces` R)var info={};var browserFamily=ca.base.util.`1D!er.get` 9"();if(` E)!="MSIE"`!O%info;}var commonPluginKeys=["`4U!","QuickTime","`4,%","`&k.","Silverlight","Java"];for(`"&!=0;i<` {,.length;i++`"L"p` 6!Name=` <,[i]`"d!` ="Version="";try{` \'*` O"Detec`#s!` 1#(` t&);}catch(e1){RMLogger.log(e1.message);}info[` L&]=` {)`(<#`(u)()`!`!cc=`(i0;info.VB`!a$`-e"EngineMajor`!b$)+"."+` 2)in` #8Build` 6%`!""Conne`&+!Type=cc.c` %)`$4%key in `&m"omponentMap`$."val=cc`"&!` 4$`!!$` A-[key],"` @%ID"`&g!!val||val`%+#==0){continue`#a#key]=val`#P#`)u,();`\'.)`(1"FLASH_REQ_VERSION_MAJ=8` $4IN=5` %3REV=0;ca.rm.job.`\'!={ID:"riskminder`,B"",FILE:"devicedna/` 8&-` =".swf",VARS:"readyCallback=flashR` \'(&error` 3*E` \'(",` /!C`.X!d:false`+t!ookie`+,&c` +!Name,` %"Stor` +!`$d"` /"`,T"if(_rm`!g"_instance_.`!$!NotRequired`0\'& `-+"var obj`+t*`#\'!.getHandle`%R"ID`%5"obj`(u+"`"9!: ` R! object unavailable"`%"%`!."try{`!u#obj`&d"okie`"58`*8%`!%3Unable to invoke`!F#methods");` A1"+e.name+" -` (!`+"&`!k#`!B"`/:6p`&Z!`/R$`#$~`#8j`+S!Fonts`$"$FontList`+l%amera`$?%` )!` 4(Microphon`$c%` (&` Z*pabilitie`!#%` (((`$ ~`$k3`+y",init`)0\'`)d#){`$BM`$h"fpv`$W3` $!`3`"`/W&` M"reqv=new ` H.` C*[`-S1,`-M1` #/REV]`!."validFP`1y$fpv.v` &"IsValid(`!P"`/m%` C\'){`"~$(`,^!`&8$`"["movieURL=`#*0getBaseURL()+"/"+`\'W!FILE`!#!` )!`-X(){`#9/c` 7!`(/$,`!)$,` ,!VARS);` X-=true;}check` a!Loaded(0,`%)%;}};` N!` 5"=`"7!` ,"`/Z)=`*_\'` D(` |";` s,` E&count`!&&{if` -">4`)u9loading timed out");`#i4if(`!H\'`$>\'tru` <\'`!2!++;setTimeout(`"*\'`"t-`!j+;},50);}`3Y(ont={f`+=#:["cursive","monospace","serif","sans-` %$fantasy","default","Arial",` "" Bl`38!` \'#Narrow` &%Rounded MT Bold","Bookman Old Style","Bradley Hand ITC","Century",` "$ Gothic","Comic Sans MS` +!urier` 5!` %! New","Georgia` %!ntium","Impact","King","Lucida Conso`!F!Modena` $!notype Corsiva","Papyrus","Tahoma","TeX","Time` 2!imes New Roman","Trebuchet`!e"Verda` z!Verona"]`1j4`1w!new Array`*q!names;if(arguments.length<1){` 8!=`(t"`%"#;}else` 3#` K%[0]`&e!!` 3!`2I%`.J"var detective`-,$`%#D` 3!or`-P"ont;for(`!g!=0;i<` k!`!K#;i++)`&M!=` 2![i];if(` r%.` $"(font))`2K"push` +";}`/x*`\'@(`!>$`*<(var base`3-"[`\'G*`\'A(` ""]`!}!testString="mmmmmmmmmmlli"` 5&ize="72px` ."h=doc`#A!.getEle`#L!ByTagName("body")[0` |"s` E&`-O"` K#("span");s.style`$L!`!\'!`!-$;s.innerHTML` /"`!d!` q!`)@#Width={}` ((Height={}`$0&ndex in`"u&){`!*(Family=` 5%[` L!];h.appendChild(s);`!*([` ?,]=s.offse` :"` E$`!I"` 37` ;";h.remove`!$%}`$t$`&e#`%P"`%"!` +"`/v&`!zJfont+","+`"/>`3(!atched`"0*!=`"N:||`"1*` G%`"W4`"N.`"<%`"F$||`!D#;`(1$` 2$;}`*N!` )"` I#`/o)HMID={`+I8`%}#props;try{` %!`+E"getHMID();if(` 3!!=null`)l#Version=` 5!.v` (";` 6!MID` 0#DNA`,##`!u#null;}}catch(e`3G3"+e.name+" -` (!message)`"Z%`*v",`!\\#`"+,`")"`)B!tor`,`(` +!.StoreDID` 9&Type=` 7"getType`"Q"` 3&="plugin"` |#` (!=(`/!!uthMinderP` 1!).get` %"`#6#` 1"`#V#{`#%#:"1",DNA:null`$""status=` J".GetDeviceDNA`#{"`!M#` @!=`!\',.E_SUCCESS`/P%`"c"}`#n0`$"/`%o(MESC={isMESCEnabled:true,mescInstance`!u!,calibrationStartTime:0,runAgainTimerHandl` I#stopRu` &.` u!te` d"Count:0` 0!Valu` 9\'`!%\'Du` ""` B#max` X%s` -#intervalDelay:0`!9!Now:`+?!`!D$`%u(try{`!Q.`\'u!`$?!endTime`%5"Date`%*!Time(`+4"elapse` ?"` F#-`"p0;console.info("MESC `!2# --- updating `"[% with` x$ "+` \');`)o!` B%`)}"` &%+";ldi=` F);`)<&}},calculateMESC`(a,num_iter=0`+ !var curren`"$!`"P7`"q7+`!Y%`$^/;while(` z\'<` e#){`!E$++;`!$=`+J<U`\'V! to invoke `$!!method");`+gS`!Z$`,<"Averag`#@4berOfSamples=1`#1!a` K"`#b\'total=0`2I&=0;i<` O+;i++` q"s` ,!`%="`$k)();` f!+=` =";}`!$$Math.round(` =!/` n+)`%b(`"@#` U#;},clear`(I!`0z)`)%#=true;if(`*`/`0k$` Y%out` 40);` "/`)O"}`/""`)b+` d1` 5.);` -#`%h!,newCollectMESCFunc`*n)`\'*$`,9*`$>\'newVal`37%`%0\'(`)R,+=";mesc="+` P"` 6&` q*+=1`((#` *3<` /%`-4)`%F"delayMaker=ca.base.util.RMSleep;` 6&.sleep` {&`-m));`!Ct`)X\'}},proces`%y)`\'l!nfo={}` ^&`"=)=_rmclient_i`1T#_.getMescM` C"s`!Y(`+^/` G8C` =.` b(`"{)` L8I` =(`#$-="mi="`-L&`"5)+";cd` 2(`!p/+";i` 7)`!L)`&~!` 6!`\'R.();info` P!`0J+;`*E#info`0D)};ca.rm.job.Plugin={`$>;if(typeof google!="undefined"`3s"var gearsVersion=` D".` /!.factory.getBuildInfo`!t$Gears=` P(`!b)`!2&crypto`!/)&&` /".v` T"){info[\'Personal Security Manager\']=` D*`, !!navigator.p`"m!s||` "..length){`#M)var regex=/\\d+([\\.|_|-|,]\\d+)+/g`04!str,match,`!/$`0"+` u3`00&` 2"=` 8-[i];if(` ("`"]&` "#=` **;}else{str` 1$`2h#| "+` +#descrip`4g!`!n!=str.` %!(`"C!);` u$` 0!?` 6![0]:"";}`#z!` q\']=`!2%`#)),getJS`%)#`&G,parent=document.getElementsByTagName("head")[0]||` +;body` E!`#g+9;++i`3r#`"O!`!)&create` e#("` 9"");if(i==0){` ,".language="Java` @#`#_$` )61."+i;}` ;#text="caJ`\'y$ = ` =!+";";`"h".appendChild(` R")` 3$remove` -*`#g$` k\'`#p"` &#FromString`#t&str){`*s)Scree`*]?nfo.FullHeight=s` R!.h` )!` 8"Av` .+avai` ,#` V&Width` :$width` U%` .)` X!` -!` :"BufferDep` 9&b` )&` >"Colo` 5*c` )%` <"Pixel` 5)p` )%` <"DeviceXDPI` :$d` )%` 6(Y` 1-Y` 9%FontSmoothing` =$f` )(Enabled` I"Update`1:$` H$u` ))`/^*`$T)ystem`$;BPlatform`+X)` -"` ;"OSCPU` 3\'oscpu?` D&` +!:` &&cpuClass` X"s`!F!L`(&$` =&`(9$` A"user` 2/` +(` C"Timezone=(new Date).get` /$Offset()`"f2store.StoreDID=`"n%props)`3i"`$S"locker=` 4!&&"` )("in ` 3!?` 9!` D):null;` |!Base.call(this,` }";`!42.prototype=new ` W%({inheriting:true})` J2base=`!-&` f%` o;.serialize`"b&did`2C%escape` .!`!Y=.de` X2Str` h%un` i&Str` S?isValidEntry` m&key,data){if`#[!.didname!="undefined"&&` -*null&&key==` -(`!U%true`/?#` +#false`%h4`#;)tDIDNam`"P\'` u"` }(=nam`#|3base.migrat`%k\');};'
  )
);



//////////////////
// WEBPACK FOOTER
// ./src/lib/riskminder/riskminder.js
// module id = 3
// module chunks = 0